import type {Listing} from "@hosttools/frontend/models/listing";
import type {CellContext} from "@tanstack/react-table";
import type React from "react";
import {memo} from "react";

import ListingChannels from "@/client/components/Settings/Listings/ListingChannels";

type Props = CellContext<Listing, unknown>;

const ListingChannelsCell: React.FC<Props> = ({row: {original: listing}}) => {
    return <ListingChannels canRemoveChannel={false} listing={listing} />;
};

export default memo(ListingChannelsCell);
